import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_string } from '@/state/ui/_base/LOCAL__ui_set_string';
import { assert_instanceof, assert_not_null } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { DTO_GRAPH__edge } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__edge';
import { BaseEdge, EdgeProps, getBezierPath } from '@xyflow/react';
import { memo } from 'react';

export const G_GRAPH__edge_default = memo(function G_GRAPH__edge_default({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  markerStart,
  data,
}: EdgeProps) {
  assert_not_null(data);
  assert_instanceof(data, DTO_GRAPH__edge);

  let edge = data;

  const dispatch = use_dispatch();
  /*
   * STORE
   */

  const { g_graph__node_id_selected, g_graph__edge_id_selected } = use_slice_ui(['g_graph__node_id_selected', 'g_graph__edge_id_selected']);
  const is_selected_by_node = g_graph__node_id_selected == edge.field_from__node_id || g_graph__node_id_selected == edge.field_to__node_id;
  const is_selected = g_graph__edge_id_selected == edge.edge_id;

  /*
   * STATE
   */
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  /*
   *
   */
  use_effect(() => {
    return () => {
      if (!is_selected) return;

      dispatch(LOCAL__ui_set_string({ value: ENUM__string_id_empty.UUID, key: 'g_graph__edge_id_selected', valid_values: [] }));
    };
  }, []);

  /*
   *
   */

  /*
   *
   */

  function get_style() {
    let out: Record<string, any> = {};

    if (is_selected) {
      out.strokeWidth = 10;
      out.strokeDasharray = '5 5';
    } else if (is_selected_by_node) {
      out.strokeWidth = 5;
      out.strokeDasharray = '2 2';
    } else {
      out.strokeWidth = 2;
    }

    return out;
  }

  return (
    <BaseEdge
      path={edgePath}
      interactionWidth={20}
      {...{ markerEnd, markerStart }}
      className={`stroke-[#6b7280] 
    `}
      style={get_style()}
    />
  );
});
